import { render, staticRenderFns } from "./Coffees.vue?vue&type=template&id=4d31e22e&"
import script from "./Coffees.vue?vue&type=script&lang=js&"
export * from "./Coffees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports